import React from 'react'
import Icon from '../../Shared/Components/Icon'
import { RecyclingOptionProps } from '../types'

const RecyclingOption = (props: RecyclingOptionProps) => {
    return (
        <div className='recycling-options'>
            <div className='recycling-options__label-wrapper'>
                <span className='recycling-options__description'>
                    {props.description}
                </span>
                <span className='recycling-options__label'>
                    {props.label}
                </span>
            </div>
            <Icon iconName={props.iconName} size={28} />
        </div>
    )
}

export default RecyclingOption